import React from 'react';
import { GiCheckMark } from "react-icons/gi";

export default function Component(props) {

  const { question, answersList, surveyLanguageCode, handleRadio, clicked, surveyScreenData } = props;

  console.log("surveyScreenData---x----x---x>", surveyScreenData)

  return (
    <>
      {/* <div className="w-full space-y-3">
        {question && question.optionsList && question.optionsList.length > 0 ?
          question.optionsList.map((option, optionindex) =>
            <button
              key={optionindex}
              style={{
                color: (answersList.some(item => option.id === item.questionOptionId)) || (clicked === option.id) ? surveyScreenData && surveyScreenData.OptionColor2 ? surveyScreenData.OptionColor2 : 'black' : (surveyScreenData && surveyScreenData.OptionColor2) ? surveyScreenData.OptionColor2 : "#757575",
                background: (answersList.some(item => option.id === item.questionOptionId)) || (clicked === option.id) ? (surveyScreenData && surveyScreenData.OptionColor3) ? surveyScreenData.OptionColor3 : "#757575" : (surveyScreenData && surveyScreenData.OptionColor1) ? surveyScreenData.OptionColor1 : '#757575',
              }}
              onClick={() => handleRadio(optionindex, question, option)}
              className="w-full p-2 rounded-sm text-center text-base " >{(surveyLanguageCode !== '') ?
                (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id]) ?
                  question.transl[surveyLanguageCode].optionsList[option.id] : option.name

                : option.name}</button>
          ) : null}
      </div> */}

      <div className="w-full space-y-3 2xl:w-4/5 xl:w-1/2 lg:w-11/12">
        {question && question.optionsList && question.optionsList.length > 0 ?
          question.optionsList.map((option, optionindex) => {

            const isSelected =
              answersList.some(item => option.id === item.questionOptionId) ||
              clicked === option.id;

            const textColor = isSelected
              ? surveyScreenData?.optionTextActiveColor || "#FFFFFF"
              : surveyScreenData?.optionTextColor || "#FFFFFF";

            const bgColor = isSelected
              ? surveyScreenData?.optionBgActiveColor || "#5ACC66"
              : surveyScreenData?.optionBgColor || "#3B92D4";

            const borderColor = isSelected
              ? surveyScreenData?.optionBorderActiveColor || "#5ACC66"
              : surveyScreenData?.optionBorderColor || "#3B92D4";


            console.log("optionindex---x----x---x>", optionindex)
            console.log("borderColor---x----x---x>", borderColor)


            return (
              <button
                key={optionindex}
                style={{ color: textColor, background: bgColor, borderColor: borderColor }}
                onClick={() => handleRadio(optionindex, question, option)}
                className="w-full py-2 px-4 rounded-md text-center text-base flex justify-between items-center border font-medium"
              >
                {/* -------- Option Text -------- */}
                {(surveyLanguageCode !== '') ?
                  (question?.transl?.[surveyLanguageCode]?.optionsList?.[option.id]) ?
                    question.transl[surveyLanguageCode].optionsList[option.id] : option.name
                  : option.name}

                {/* -------- Check Icon -------- */}
                {isSelected && <GiCheckMark size={22} />}
              </button>
            );
          })
          : null}
      </div>


    </>
  );
}